module.exports = __webpack_public_path__ + "img/91263.73b2cf36.svg";